<template>
  <el-dialog
    :title="isReadOnly?'查看终端':`编辑终端`"
    :visible.sync="visible"
    width="1000px"
    @close="handleClose"
  >
    <!-- 基本信息 -->
    <el-card class="card-container">
      <span slot="header" class="card-header-title">基本信息</span>
      <el-descriptions :column="3" border size="small">
        <el-descriptions-item label="终端SN">{{
          formData.posSn
        }}</el-descriptions-item>
        <el-descriptions-item label="终端类型">
          <el-select
            v-model="formData.amountType"
            placeholder="请选择"
            clearable
            class="edit-select"
            :disabled="isReadOnly"
          >
            <el-option
              v-for="item in amountTypeOptions"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            />
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="是否激活">
          <el-select
            v-model="formData.hasActivate"
            placeholder="请选择"
            clearable
            class="edit-select"
            :disabled="isReadOnly"
          >
            <el-option label="是" :value="1" />
            <el-option label="否" :value="0" />
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="分公司">{{
          getGroupName(formData.groupId)
        }}</el-descriptions-item>
        <el-descriptions-item label="业务员">{{
          getSalesName(formData.salesId)
        }}</el-descriptions-item>
        <el-descriptions-item label="平台">{{
          formData.platfromName
        }}</el-descriptions-item>
        <el-descriptions-item label="入库时间">{{
          formData.storeTime
        }}</el-descriptions-item>
        <el-descriptions-item label="下拨时间">{{
          formData.allocateTime
        }}</el-descriptions-item>
        <el-descriptions-item label="回拨时间">{{
          formData.callbackTime
        }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <!-- 操作历史 -->
    <el-card class="card-container">
      <span slot="header" class="card-header-title">操作历史</span>
      <el-table
        :data="formData.transferRecordList"
        stripe
        border
        style="width: 100%"
      >
        <el-table-column
          prop="transferType"
          label="操作类型"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.transferType === 0" class="tag-allocate"
              >下拨</span
            >
            <span v-else-if="scope.row.transferType === 1" class="tag-callback"
              >回拨</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="oldGroupName"
          label="分公司"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="groupName"
          label="新分公司"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="oldSalesName"
          label="业务员"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="salesName"
          label="新业务员"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="allocateTime"
          label="下拨时间"
          min-width="160"
          show-overflow-tooltip
        />
        <el-table-column
          prop="callbackTime"
          label="回拨时间"
          min-width="160"
          show-overflow-tooltip
        />
      </el-table>
    </el-card>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" :disabled="submitLoading">取消</el-button>
      <el-button v-if="!isReadOnly" type="primary" @click="handleSubmit" :loading="submitLoading"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  getTerminalDetail,
  updateTerminal,
  getGroupListToTerminal,
  getUserListByLogin,
} from "@/api/erp/terminal";

export default {
  name: "TerminalEditDialog",
  data() {
    return {
      visible: false,
      submitLoading: false,
      editId: null,
      formData: {
        id: "",
        posSn: "",
        platfromName: "",
        brand: "",
        model: "",
        storeTime: "",
        allocateTime: "",
        callbackTime: "",
        hasActivate: "",
        groupId: "",
        salesId: "",
        amountType: "",
        transferRecordList: [],
      },
      groupList: [],
      salesList: [],
      amountTypeOptions: [
        { code: "199", desc: "199" },
        { code: "299", desc: "299" },
        { code: "399", desc: "399" },
      ],
      isReadOnly: false,
    };
  },
  methods: {
    open(id, isReadOnly) {
      this.editId = id;
      this.isReadOnly = isReadOnly || false;
      this.visible = true;
      this.getGroupList();
      this.getUserList();
      this.getTerminalDetail();
    },
    // 获取分公司列表
    async getGroupList() {
      try {
        const { data } = await getGroupListToTerminal();
        this.groupList = data || [];
      } catch (error) {
        this.$message.error("获取分公司列表异常");
        this.groupList = [];
      }
    },
    // 获取业务员列表
    async getUserList() {
      try {
        const { data } = await getUserListByLogin();
        this.salesList = data || [];
      } catch (error) {
        this.$message.error("获取业务员列表异常");
        this.salesList = [];
      }
    },
    // 获取编辑数据
    async getTerminalDetail() {
      try {
        const { data } = await getTerminalDetail(this.editId);
        this.formData = data;
        if (Array.isArray(data.transferRecordList)) {
          this.formData.transferRecordList = data.transferRecordList;
        } else {
          this.formData.transferRecordList = [];
        }
      } catch (error) {
        this.$message.error("获取终端信息失败");
        this.handleClose();
      }
    },
    // 获取分公司名称
    getGroupName(groupId) {
      const group = this.groupList.find((item) => item.id === groupId);
      return group ? group.name : "-";
    },
    // 获取业务员名称
    getSalesName(salesId) {
      const sales = this.salesList.find((item) => item.id === salesId);
      return sales ? sales.name : "-";
    },
    // 提交编辑
    async handleSubmit() {
      if (this.submitLoading) {
        return;
      }

      this.submitLoading = true;
      try {
        await updateTerminal({
          id: this.formData.id,
          amountType: this.formData.amountType,
          hasActivate: this.formData.hasActivate,
        });
        this.$message.success("编辑成功");
        this.$emit("success");
        this.handleClose();
      } catch (error) {
        this.$message.error("编辑失败");
      } finally {
        this.submitLoading = false;
      }
    },
    // 关闭对话框
    handleClose() {
      this.visible = false;
      this.resetForm();
    },
    // 重置表单
    resetForm() {
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>

<style scoped lang="scss">
.card-container {
  margin-bottom: 20px;
}

.card-header-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.edit-select {
  width: 100%;
}

.tag-allocate {
  background-color: #67c23a;
  color: white;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
}

.tag-callback {
  background-color: #f56c6c;
  color: white;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
